<template>
    <Layout :footer-style="2">
        <!-- Start Slider Area -->
        <div class="demo-slider-area slider-area bg-transparent slider-style-1 pb--100 pt--70">
            贵州通济智医科技有限公司（简称“通济智医”）成立于2020年12月，是一家以物联网自动化技术和大数据为基础，专注于提供全场景智慧医药终端生态链服务的综合服务商。公司核心团队在医疗行业拥有近二十年的深耕经验，致力于通过技术创新优化药品流通和医疗服务体验。

以下是对其智能医柜功能及业务的详细介绍：

🏥 一、核心产品：无菌智能无人药房
通济智医的旗舰产品是“​​无菌智能无人药房​​”，这款智能医柜融合了多项技术创新，旨在提升药品零售的便捷性、安全性和效率。

🔬 主要功能特点：
1.
​​222纳米远紫外线杀菌技术​​：这是全国首家应用该技术的智能无人药房。此技术能快速消杀柜内及周边环境，有效降低交叉感染的风险，为患者和医护人员提供更安全的购药环境。
2.
​​多种支付方式支持​​：智能医柜支持​​微信支付、支付宝、银联云闪付、Apple Pay、三星智付​​等多种移动支付方式，同时也兼容​​IC卡支付、NFC手机支付​​等，满足不同用户的支付习惯，方便快捷。
3.
​​远程监控与智能管理​​：
•
配备​​GPRS防盗报警系统​​和​​监控摄像头​​，支持远程监听、报警、喊话、监视和录像功能，确保设备安全。
•
通过​​4G、Wi-Fi​​等网络实现远程实时控制，可更新和发布多媒体文件，并支持柜内环境参数、存储状况的监控和报警。
•
部分智能柜型号支持​​GPS/北斗定位系统​​，便于实时监控设备位置。
4.
​​灵活的货仓配置​​：可根据商品特性定制“履带式货仓”、“弹簧式货仓”、“挂钩式货仓”或“大容量货仓”，以适应不同药品和医疗用品的售卖需求。
5.
​​物联网与数据整合​​：利用物联网技术打通“人与社区/乡镇-医院/医生-药店/药房”的医药产品流通信息化管理系统，实现药品从入库到消耗的全流程追溯和精细化管理。
📊 二、业务模式与市场应用
通济智医的业务模式围绕智慧医药终端生态链展开，具体包括：

•
​​业务定位​​：公司是​​无菌智能无人药房经营商​​，专注于医疗产品零售终端自助设备和智慧医药SaaS软件平台的研发。
•
​​合作与融资​​：公司在2023年1月完成了​​2000万元人民币的Pre-A轮融资​​，由鑫资本集团领投，香港永安達集团旗下永安達资本跟投。资金主要用于市场推广、团队建设以及无菌智能无人药房项目在全国的快速推广。此外，在2023年10月，通济智医还与华润医商润小医、先健科技医信家签署了互联网医院智慧一体化服务合作协议，旨在协同线上线下资源，优化医疗资源配置，服务更多患者。
•
​​市场覆盖​​：截至目前，通济智医的无菌智能无人药房已成功进驻​​全国15个省份​​，约​​上百家医院​​引入并使用该设备。其平台在销产品品规已突破3000个，合作厂家达800家。
•
​​目标用户与场景​​：智能医柜主要服务于​​公立医院​​、​​社区医疗中心​​等场景，满足患者​​24小时便捷购药​​需求，尤其适用于夜间急用药、不愿进店或需要减少人员接触的场景。
💎 三、总结
贵州通济智医科技有限公司通过其创新的无菌智能无人药房，不仅提供了​​安全、便捷、高效​​的药品零售新方式，还通过物联网技术实现了药品管理的​​数字化和智能化​​。其业务发展迅速，市场认可度高，并与多家行业巨头达成战略合作，共同推动互联网医疗智慧服务的发展。

希望以上信息能帮助您全面了解贵州通济智医科技有限公司的智能医柜。

贵州通济智医科技有限公司是一家专注于“医疗+人工智能+物联网”技术融合的高科技企业，致力于通过智能化终端设备和数字化平台，为医疗机构、社区及家庭提供便捷、高效、安全的医药健康服务解决方案。其核心产品“智能医柜”是这一战略的集中体现。

​​一、 智能医柜核心功能详细介绍​​
智能医柜本质上是一个​​物联网化的智能药品与医疗器械零售/管理终端​​。它集成了多种技术，主要功能可归纳为以下几点：

​​1. 智能零售功能（核心面向C端用户）​​

•
​​24小时自助购药：​​ 用户可通过触摸屏或手机扫码，随时在柜内购买常见的非处方药（OTC）、医疗器械（如血压计、体温计、创可贴）、保健品、计生用品等，解决夜间或紧急用药需求。
•
​​多种支付方式：​​ 支持微信、支付宝、银联云闪付等多种主流移动支付方式，交易流程便捷。
•
​​商品信息展示：​​ 屏幕上可清晰展示药品的图片、名称、功效、价格、生产厂家、使用说明等信息，方便用户自主决策。
•
​​智能温湿度控制：​​ 柜内配备温湿度传感器和控制系统，能确保药品和器械在合适的条件下储存，保障产品品质和安全。
​​2. 智慧管理功能（核心面向B端运营方）​​

•
​​远程实时监控：​​ 运营人员可通过云端管理平台，实时查看每个智能医柜的库存状态、销售数据、设备运行状态（如门锁、温度、网络）、交易记录等。
•
​​库存智能预警与补货提醒：​​ 系统会根据销售数据自动预测库存，当商品库存低于安全阈值时，会自动向运维人员发送补货提醒，极大提高运营效率。
•
​​一键远程调试：​​ 支持对设备进行远程重启、锁定、升级软件等操作，减少线下运维成本。
•
​​大数据分析：​​ 后台系统能收集和分析销售数据、用户购买行为等，生成可视化报表，为选品优化、精准营销和业务决策提供数据支持。
​​3. 安全与合规保障​​

•
​​智能身份识别（可选）：​​ 部分用于特殊药品管理的柜体可支持刷身份证、医保卡或人脸识别，确保用药安全与合规。
•
​​全方位监控：​​ 设备通常配备监控摄像头，对购买行为进行记录，既可防盗，也可在发生纠纷时提供追溯依据。
•
​​GSP合规存储：​​ 柜体的设计遵循GSP（药品经营质量管理规范）对存储环境的要求，确保药品质量。
​​4. 便民服务与增值功能（扩展功能）​​

•
​​健康科普宣传：​​ 屏幕可循环播放疾病防治、合理用药等健康知识科普视频，成为社区健康宣传站。
•
​​附近药店导航：​​ 集成LBS服务，为用户推荐附近的线下药店，形成O2O联动。
•
​​互联网医院入口（未来扩展）：​​ 可作为线上问诊的线下终端，用户通过医柜与在线医生视频连线，获得用药指导后直接购药。
​​二、 公司业务介绍​​
通济智医的业务不仅仅是销售一台硬件设备，而是提供一整套​​“智能硬件+ SaaS软件平台+运营服务”​​ 的综合性解决方案。

​​1. 核心业务模式：​​

•
​​智能医柜的销售与铺设：​​ 向医院、药店、社区、学校、企业、机场/火车站等公共场所销售或投放智能医柜设备。
•
​​SaaS软件服务平台订阅：​​ 为客户提供云端的管理后台服务，按月/年收取软件服务费。这是其持续性的收入来源之一。
•
​​运营与维护服务：​​ 为客户提供包括设备安装、调试、日常补货、清洁、故障维修等一站式运营托管服务。
•
​​广告与数据服务：​​ 利用智能医柜的显示屏开发广告业务；同时，脱敏后的区域健康消费数据可以为药企、研究机构提供市场洞察服务。
​​2. 主要应用场景与客户：​​

•
​​医院场景：​​
•
​​院内：​​ 部署在门诊大厅、住院部走廊，销售非处方药和日常护理用品，方便患者和家属，减轻药房窗口压力。
•
​​院外：​​ 部署在医院周边，为出院患者和周边居民提供24小时便民药事服务。
•
​​连锁药店场景：​​
•
作为药店业务的延伸，部署在药店门口或人流量大的区域，实现24小时无人售药，降低人力成本，扩大服务半径。
•
​​社区/政务场景：​​
•
部署在社区服务中心、街道办、党群服务中心，打造“15分钟便民健康生活圈”，成为智慧社区的重要组成部分。
•
​​企业/学校场景：​​
•
为员工和学生提供便捷的常用药品和应急医疗用品购买渠道，成为企业福利和校园安全的配套设施。
•
​​公共场所：​​
•
机场、火车站、高速公路服务区等，满足旅客紧急用药需求。
​​3. 公司价值主张：​​

•
​​对政府/社区：​​ 助力“互联网+医疗健康”和“智慧城市”建设，提升公共医疗服务的可及性和便捷性。
•
​​对医院/药店：​​ 降本增效，延伸服务时空，数字化升级，创造新的营收点。
•
​​对用户（居民）：​​ 提供24小时触手可及的便捷购药体验，满足突发性、应急性健康需求。
​​总结​​
贵州通济智医科技有限公司通过其​​智能医柜​​产品，正在构建一个连接药品供应商、医疗机构、药房和最终用户的智能化健康服务网络。它不仅仅是一个自动售货机，更是一个​​社区健康服务的智能节点​​和​​医药零售数字化转型的基础设施​​，其背后的软件平台和数据分析能力是其真正的核心竞争力。
一、 智能医柜核心功能详细介绍​​
智能医柜本质上是一个​​物联网化的智能药品与医疗器械零售/管理终端​​。它集成了多种技术，主要功能可归纳为以下几点：

​​1. 智能零售功能（核心面向C端用户）​​

•
​​24小时自助购药：​​ 用户可通过触摸屏或手机扫码，随时在柜内购买常见的非处方药（OTC）、医疗器械（如血压计、体温计、创可贴）、保健品、计生用品等，解决夜间或紧急用药需求。
•
​​多种支付方式：​​ 支持微信、支付宝、银联云闪付等多种主流移动支付方式，交易流程便捷。
•
​​商品信息展示：​​ 屏幕上可清晰展示药品的图片、名称、功效、价格、生产厂家、使用说明等信息，方便用户自主决策。
•
​​智能温湿度控制：​​ 柜内配备温湿度传感器和控制系统，能确保药品和器械在合适的条件下储存，保障产品品质和安全。
​​2. 智慧管理功能（核心面向B端运营方）​​

•
​​远程实时监控：​​ 运营人员可通过云端管理平台，实时查看每个智能医柜的库存状态、销售数据、设备运行状态（如门锁、温度、网络）、交易记录等。
•
​​库存智能预警与补货提醒：​​ 系统会根据销售数据自动预测库存，当商品库存低于安全阈值时，会自动向运维人员发送补货提醒，极大提高运营效率。
•
​​一键远程调试：​​ 支持对设备进行远程重启、锁定、升级软件等操作，减少线下运维成本。
•
​​大数据分析：​​ 后台系统能收集和分析销售数据、用户购买行为等，生成可视化报表，为选品优化、精准营销和业务决策提供数据支持。
​​3. 安全与合规保障​​

•
​​智能身份识别（可选）：​​ 部分用于特殊药品管理的柜体可支持刷身份证、医保卡或人脸识别，确保用药安全与合规。
•
​​全方位监控：​​ 设备通常配备监控摄像头，对购买行为进行记录，既可防盗，也可在发生纠纷时提供追溯依据。
•
​​GSP合规存储：​​ 柜体的设计遵循GSP（药品经营质量管理规范）对存储环境的要求，确保药品质量。
​​4. 便民服务与增值功能（扩展功能）​​

•
​​健康科普宣传：​​ 屏幕可循环播放疾病防治、合理用药等健康知识科普视频，成为社区健康宣传站。
•
​​附近药店导航：​​ 集成LBS服务，为用户推荐附近的线下药店，形成O2O联动。
•
​​互联网医院入口（未来扩展）：​​ 可作为线上问诊的线下终端，用户通过医柜与在线医生视频连线，获得用药指导后直接购药。
​​二、 公司业务介绍​​
通济智医的业务不仅仅是销售一台硬件设备，而是提供一整套​​“智能硬件+ SaaS软件平台+运营服务”​​ 的综合性解决方案。

​​1. 核心业务模式：​​

•
​​智能医柜的销售与铺设：​​ 向医院、药店、社区、学校、企业、机场/火车站等公共场所销售或投放智能医柜设备。
•
​​SaaS软件服务平台订阅：​​ 为客户提供云端的管理后台服务，按月/年收取软件服务费。这是其持续性的收入来源之一。
•
​​运营与维护服务：​​ 为客户提供包括设备安装、调试、日常补货、清洁、故障维修等一站式运营托管服务。
•
​​广告与数据服务：​​ 利用智能医柜的显示屏开发广告业务；同时，脱敏后的区域健康消费数据可以为药企、研究机构提供市场洞察服务。
​​2. 主要应用场景与客户：​​

•
​​医院场景：​​
•
​​院内：​​ 部署在门诊大厅、住院部走廊，销售非处方药和日常护理用品，方便患者和家属，减轻药房窗口压力。
•
​​院外：​​ 部署在医院周边，为出院患者和周边居民提供24小时便民药事服务。
•
​​连锁药店场景：​​
•
作为药店业务的延伸，部署在药店门口或人流量大的区域，实现24小时无人售药，降低人力成本，扩大服务半径。
•
​​社区/政务场景：​​
•
部署在社区服务中心、街道办、党群服务中心，打造“15分钟便民健康生活圈”，成为智慧社区的重要组成部分。
•
​​企业/学校场景：​​
•
为员工和学生提供便捷的常用药品和应急医疗用品购买渠道，成为企业福利和校园安全的配套设施。
•
​​公共场所：​​
•
机场、火车站、高速公路服务区等，满足旅客紧急用药需求。
​​3. 公司价值主张：​​

•
​​对政府/社区：​​ 助力“互联网+医疗健康”和“智慧城市”建设，提升公共医疗服务的可及性和便捷性。
•
​​对医院/药店：​​ 降本增效，延伸服务时空，数字化升级，创造新的营收点。
•
​​对用户（居民）：​​ 提供24小时触手可及的便捷购药体验，满足突发性、应急性健康需求。
​​总结​​
贵州通济智医科技有限公司通过其​​智能医柜​​产品，正在构建一个连接药品供应商、医疗机构、药房和最终用户的智能化健康服务网络。它不仅仅是一个自动售货机，更是一个​​社区健康服务的智能节点​​和​​医药零售数字化转型的基础设施​​，其背后的软件平台和数据分析能力是其真正的核心竞争力。

贵州通济智医科技有限公司智能医柜功能详细介绍和业务介绍
以下是针对​​贵州通济智医科技有限公司智能医柜​​的功能模块与业务布局的详细拆解，结合医疗场景实际需求与技术实现逻辑，从“硬件终端功能”“软件平台能力”“业务生态模式”三方面展开说明：

一、智能医柜核心功能详细介绍
智能医柜是融合“物联网（IoT）+人工智能（AI）+医药专业管理”的智能终端设备，本质是“24小时无人值守的社区级医药服务站”。其功能设计围绕“用户购药便捷性”“运营管理高效性”“药品存储安全性”“数据服务价值性”四大维度展开，具体功能如下：

（一）用户侧：智能购药与便民服务功能
1. ​​全时段自助购药​​
•
​​24小时无间断服务​​：突破传统药房营业时间限制，覆盖夜间、节假日等紧急用药场景（如感冒发烧、跌打损伤、慢性病临时缺药）。
•
​​多品类商品覆盖​​：柜内商品以“高频刚需+安全可控”为原则，主要包括：
•
​​非处方药（OTC）​​：感冒药、肠胃药、退烧药、皮肤外用药等常见病症用药；
•
​​医疗器械​​：体温计、血压计、血糖仪、创可贴、口罩、消毒棉片等家用医疗耗材；
•
​​保健食品/用品​​：维生素、钙片、助眠类营养品、成人/儿童护理用品等；
•
​​特殊扩展品类​​（需资质支持）：部分地区的计生用品、急救药品（如硝酸甘油片）等。
2. ​​极简交互体验​​
•
​​多模态操作入口​​：用户可通过柜体触摸屏（图文+视频指引）、手机扫码（小程序/APP跳转）、人脸识别（可选）等方式快速启动购药流程。
•
​​智能导购辅助​​：屏幕提供“按症状推荐”功能（如输入“头疼”“咳嗽”），结合药品功效标签自动匹配推荐商品，并展示用法用量、禁忌提示；部分机型支持语音交互（如老人模式）。
•
​​支付与取药一体化​​：支持微信、支付宝、医保电子凭证（需对接当地医保系统）、银联云闪付等主流支付方式，支付成功后柜门自动弹开对应货道，取药后自动完成交易闭环。
3. ​​安全与合规保障​​
•
​​专业级存储环境​​：柜体内部集成温湿度传感器与智能控温模块（部分高端机型支持冷藏仓，如胰岛素等需低温保存药品），实时监测并自动调节环境参数（温度：2℃-25℃，湿度：35%-75%），符合GSP（药品经营质量管理规范）标准。
•
​​药品溯源与防伪​​：每盒药品内置电子监管码（或通过条形码扫描），系统自动核验药品来源合法性，杜绝过期、假冒商品上架；交易记录与药品流通信息绑定，支持监管部门溯源查询。
•
​​身份核验扩展​​（按需配置）：针对含麻黄碱类药品（如部分感冒药）、处方药（需对接互联网医院电子处方），支持身份证识别、人脸比对、电子处方扫码验证等功能，确保用药合规性。
4. ​​便民增值服务​​
•
​​健康科普触达​​：柜体屏幕循环播放“合理用药指南”“慢性病管理常识”“急救技能教学”等短视频（内容由合作医疗机构或药企提供），提升居民健康意识。
•
​​应急服务联动​​：部分社区场景的智能医柜与周边药店、社区卫生服务中心系统打通，当用户购买特定药品（如心脏病急救药）时，系统可同步推送“用药提醒”或“就近医疗机构联系方式”。
（二）运营侧：智能管理与数据赋能功能
1. ​​远程设备监控与运维​​
•
​​实时状态感知​​：通过物联网技术，管理平台可实时获取每台医柜的运行状态（如网络连接、门锁状态、屏幕显示、电源供应）、环境参数（温湿度、柜内光照）、库存余量（精确到每个货道的商品数量与效期）。
•
​​异常自动告警​​：当设备出现故障（如货道卡顿、温度超标）、库存不足（低于安全阈值）、支付系统异常时，系统自动向运维人员推送短信/APP通知，定位问题类型并指导快速处理。
2. ​​智能库存与供应链协同​​
•
​​动态库存管理​​：基于历史销售数据（如不同时间段、季节、区域的药品需求规律），系统自动预测补货需求，生成“补货建议清单”（包括商品种类、数量、优先级）。
•
​​效期智能预警​​：对近效期药品（如剩余有效期＜6个月）自动标记并优先推荐销售，避免过期浪费；支持“先进先出”算法，确保商品流转效率。
•
​​供应链对接​​：与医药商业公司（如国药控股、九州通）、本地药店ERP系统打通，实现订单自动生成、配送路径优化（部分区域支持“当日达”或“2小时极速补货”）。
3. ​​数据驱动的经营决策​​
•
​​用户行为分析​​：通过匿名化处理用户购买记录（如常购药品类型、购买时段、关联商品组合），生成区域健康需求画像（如某社区老年人慢性病用药占比高、年轻群体保健品需求增长快）。
•
​​选品优化建议​​：基于数据分析结果，为运营商提供“高需求低库存”“潜力新品引入”等选品策略，提升商品周转率与用户满意度。
•
​​运营效率报表​​：输出单柜日/周/月销售额、坪效（单位面积产出）、设备利用率、故障率等关键指标，辅助评估网点布局合理性（如是否需调整高流量区域布点密度）。
二、公司业务介绍：从硬件到生态的全链条布局
贵州通济智医科技有限公司的业务核心并非单一硬件销售，而是围绕“智能医柜终端”构建的“​​硬件+软件+服务+数据​​”一体化解决方案，目标是通过技术赋能解决传统医药零售的时空限制与服务效率问题，主要业务板块如下：

（一）核心产品：智能医柜终端矩阵
公司根据不同场景需求，推出差异化型号的智能医柜，主要分为：

•
​​基础款（社区/公共场所型）​​：侧重OTC药品与常用医疗器械销售，体积适中（约1.2m×0.8m），适合社区服务中心、便利店、地铁站等场景；
•
​​增强款（医院/药店延伸型）​​：增加冷藏仓（2-8℃）、大容量货道（支持更多SKU）、医保支付模块，适用于医院住院部、连锁药店门口等高需求场景；
•
​​定制款（特殊场景型）​​：如针对企业园区的“急救药品专柜”（含硝酸甘油、抗过敏药）、学校场景的“儿童安全用药柜”（防误触设计+家长监护功能）。
（二）软件平台：SaaS化管理系统
公司自主研发的“智医云平台”是智能医柜的“数字大脑”，为运营商提供：

•
​​设备管理后台​​：实时监控全国/区域医柜运行状态，支持远程配置参数（如商品定价、促销活动）、查看交易流水与用户画像；
•
​​供应链协同系统​​：对接医药供应商与物流网络，实现“需求预测-采购下单-配送跟踪-验收上架”全流程数字化；
•
​​数据分析中台​​：输出区域健康消费趋势报告、单柜经营优化建议，助力运营商精准决策。
（三）业务模式：多元化盈利与生态合作
1. ​​To G（政府/社区）​​
•
​​智慧社区健康服务站​​：与地方政府合作，在社区党群服务中心、养老驿站等场所布设智能医柜，作为“15分钟健康服务圈”基础设施，政府提供场地与政策支持，公司负责设备投放与运营，提升基层医疗服务可及性。
•
​​公共卫生应急补充​​：在疫情期间或自然灾害区域，快速部署应急医柜（储备口罩、消毒液、基础退烧药），配合政府完成物资精准投放。
2. ​​To B（医疗机构/药店/企业）​​
•
​​医院场景延伸​​：与公立医院合作，在门诊大厅、住院部走廊布设医柜，销售术后护理用品、慢性病常用药品，缓解药房窗口压力；部分项目与医院HIS系统对接，实现“出院带药续购”功能。
•
​​药店数字化转型​​：为连锁药店提供“线上商城+线下医柜”O2O解决方案，医柜作为药店的“无人前置仓”，扩大服务半径至周边3-5公里，覆盖非营业时段需求。
•
​​企业健康管理​​：为企业园区、工厂提供定制化医柜（含急救药品、员工福利保健品），作为员工健康关怀的配套设施，降低突发健康事件风险。
3. ​​To C（用户服务增值）​​
•
​​会员体系与健康管理​​：用户通过扫码购药积累积分，可兑换药品优惠券、健康检测服务（如免费血压测量）；未来计划接入互联网医院，提供“购药+用药指导+复诊提醒”闭环服务。
•
​​广告与流量变现​​：医柜屏幕空闲时段承接药企品牌广告（如新药推广）、本地生活服务广告（如社区体检中心引流），形成额外收入来源。
（四）核心优势与价值
•
​​技术壁垒​​：自主研发的物联网控温模块、药品效期管理系统、多场景适配硬件设计（如防潮、防暴、防儿童误触），保障设备稳定性和专业性。
•
​​合规能力​​：严格遵循《药品管理法》《医疗器械监督管理条例》等法规，与省级药监部门合作完成产品备案，确保经营合法性。
•
​​生态协同​​：与医药工业（药企）、商业（流通企业）、医疗机构（医院/社区中心）、支付机构（医保/第三方支付）形成合作网络，构建“医+药+险”服务闭环。
总结
贵州通济智医科技有限公司的智能医柜，本质是通过“智能终端+数字化平台”将传统医药零售场景延伸至用户身边，解决“最后一公里”乃至“最后100米”的健康服务需求。其业务逻辑不仅关注硬件销售，更聚焦于通过数据驱动运营效率提升、通过生态合作拓展服务边界，最终目标是成为“社区级健康服务的智能入口”，推动医药零售行业的数字化与普惠化转型。
        </div>
        <!-- End Slider Area -->

        <Separator/>
    </Layout>
</template>
<script type="text/javascript" src="../assets/js/js/china.js"></script> 
<script>

    export default {
        name: 'Demo',
        data() {
            return {
            }
        },
        created() {
        },
        methods: {
        },
}
</script>